module.exports = __webpack_public_path__ + "static/media/kahf.b6d059ba.jpg";